<template>
  <div>
    <!-- LIST VIEW -->
    <v-card class="mb-4" max-width="800" v-if="!gridView">
      <v-list-item three-line class="pl-0">
        <v-img
          class="mr-4"
          aspect-ratio="1"
          max-width="150px"
          :src="bannerImageUrl"
        ></v-img>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">{{
            name
          }}</v-list-item-title>
          <v-list-item-subtitle>{{ descriptionText }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-btn icon top right absolute v-on:click="removeMedia()">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-list-item>
    </v-card>
    <!-- GRID VIEW -->
    <v-card class="mb-4" max-width="400" v-if="gridView">
      <v-img v-bind:src="bannerImageUrl" class="white--text" height="200px">
        <v-card-title class="align-end fill-height">
          {{ name }}
        </v-card-title>
      </v-img>

      <v-card-text>
        <span class="text--primary">
          <span v-html="descriptionText"></span>
        </span>
      </v-card-text>

      <v-card-actions>
        <v-btn icon top right absolute v-on:click="removeMedia()">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    media: {
      type: Object,
      required: true,
      default: function() {
        return {}
      }
    },
    gridView: {
      type: Boolean,
      required: false,
      default: function() {
        return false
      }
    }
  },
  methods: {
    getMediaContent: function(media) {
      switch (media.mediaTypeId) {
        case 1:
          this.name = media.name
          this.descriptionText = media.textualContent.replace(
            /(\\r)*\\n/g,
            '<br>'
          )
          break
        case 2: //poi image
          this.bannerImageUrl =
            media.url + '?random=' + Math.floor(Math.random() * 10 + 1) //random part at the end gets random image each time from Picsum
          break
        case 6: //gallery
          this.name = media.name
          this.descriptionText = 'Media Gallery'
          break
        case 10: //poi unity component data
          break
      }
    },
    removeMedia: function() {
      this.$store.dispatch('MenuItemsStore/removeMediaForMenuItem', {
        menuItemId: this.$route.params.menuItemId,
        mediaId: this.media.id
      })
    }
  },
  data: function() {
    return {
      name: '',
      bannerImageUrl: '',
      descriptionText: ''
    }
  },
  created: function() {
    this.getMediaContent(this.$props.media)
  }
}
</script>

<style scoped></style>
